import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ToolButton from "./ToolButton";

// Tool button (bottom toolbar, next to node/edge) that starts the simplify
// flow: activating it lets the user draw a rectangle or polygon around the
// part of the network to simplify; afterwards a dialog (in MapGridDesigner)
// shows a preview per simplification degree. While the tool is active, a
// shape switch (rectangle / polygon) appears above the button, mirroring the
// Group Erase pattern.
const SimplifyTool = ({
  mapElements,
  onClick,
  active,
  onAlert,
  open,
  shape,
  setShape,
}) => {
  const { t } = useTranslation();

  const hints = {
    rectangle: t(
      "Draw a rectangle around the part of the network you want to simplify."
    ),
    polygon: t(
      "Draw a polygon around the part of the network you want to simplify. Click to add points, double-click to finish."
    ),
  };

  function handleClick(e) {
    if (!active) {
      const hasNodes = (mapElements || []).some((el) => el.type === "node");
      if (!hasNodes) {
        onAlert(t("There is nothing to simplify yet."), "warning");
        return;
      }
      onAlert(hints[shape] || hints.rectangle, "info");
    }
    onClick(e, "simplify");
  }

  function handleShapeChange(newShape) {
    setShape(newShape);
    onAlert(hints[newShape], "info");
  }

  return (
    <Box className="relative flex flex-col items-center justify-center">
      {/* shape switch appears above the button once the tool is active */}
      {active && (
        <Box
          className="absolute flex flex-row items-end gap-8"
          sx={{
            bottom: "100%",
            mb: 1,
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <ToolButton
            src={"/assets/svg/tools/shape-rectangle.svg"}
            label=""
            onClick={() => handleShapeChange("rectangle")}
            active={shape === "rectangle"}
            open={open}
            size={20}
            raiseOnActive={false}
          />
          <ToolButton
            src={"/assets/svg/tools/shape-polygon.svg"}
            label=""
            onClick={() => handleShapeChange("polygon")}
            active={shape === "polygon"}
            open={open}
            size={20}
            raiseOnActive={false}
          />
        </Box>
      )}
      <ToolButton
        src={"/assets/svg/tools/simplify.svg"}
        label={t("Simplify")}
        onClick={handleClick}
        active={active}
        open={open}
      />
    </Box>
  );
};

export default SimplifyTool;
